import React, { useEffect, useState } from 'react';

const Tile = ({ label, value, sub, tone, testid }) => (
  <div className={`rounded-2xl border p-4 ${tone}`} data-testid={testid}>
    <p className="text-[11px] uppercase font-semibold tracking-wide opacity-70">{label}</p>
    <p className="text-2xl font-bold mt-1">{value?.toLocaleString('de-CH') ?? '—'}</p>
    {sub && <p className="text-xs mt-1 opacity-80">{sub}</p>}
  </div>
);

export const UserRegistrationStats = ({ API, L }) => {
  const [s, setS] = useState(null);
  useEffect(() => { API.get('/admin/users/registration-stats').then(r => setS(r.data)).catch(() => {}); }, [API]);
  if (!s) return null;
  const pct = s.migrated_total ? Math.round((s.migrated_activated / s.migrated_total) * 100) : 0;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="user-registration-stats">
      <Tile testid="stat-active-accounts" tone="bg-slate-900 text-white border-slate-900"
        label={L('Active accounts', 'Aktive Konten')} value={s.active_accounts}
        sub={L('new signups + activated migrated', 'Neu registriert + aktivierte Migrierte')} />
      <Tile testid="stat-new-total" tone="bg-emerald-50 text-emerald-900 border-emerald-200"
        label={L('New signups (website)', 'Neu registriert (Website)')} value={s.new_total}
        sub={L(`${s.new_this_month} this month · ${s.new_last_30d} last 30 days`, `${s.new_this_month} diesen Monat · ${s.new_last_30d} letzte 30 Tage`)} />
      <Tile testid="stat-migrated-activated" tone="bg-sky-50 text-sky-900 border-sky-200"
        label={L('Migrated & activated', 'Migriert & aktiviert')} value={s.migrated_activated}
        sub={L(`${pct}% of ${s.migrated_total.toLocaleString('de-CH')} migrated`, `${pct}% von ${s.migrated_total.toLocaleString('de-CH')} migrierten`)} />
      <Tile testid="stat-migrated-pending" tone="bg-amber-50 text-amber-900 border-amber-200"
        label={L('Migrated, not yet activated', 'Migriert, noch nicht aktiviert')} value={s.migrated_pending}
        sub={s.migrated_no_email ? L(`incl. ${s.migrated_no_email} without email`, `inkl. ${s.migrated_no_email} ohne E-Mail`) : null} />
    </div>
  );
};
